import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { Sidebar } from "@/components/Sidebar";
import { Footer } from "@/components/Footer";
import { TrustBadges } from "@/components/TrustBadges";
import { FloatingContact } from "@/components/FloatingContact";
import { SplashScreen } from "@/components/SplashScreen";
import { ScrollToHash } from "@/components/ScrollToHash";
import Home from "@/pages/Home";
import DrivingTests from "@/pages/DrivingTests";
import Claims from "@/pages/Claims";
import Reviews from "@/pages/Reviews";
import FaqContact from "@/pages/FaqContact";

function App() {
  return (
    <div className="App min-h-screen bg-[#0a0a09]">
      <SplashScreen />
      <BrowserRouter>
        <ScrollToHash />
        <div className="lg:flex lg:items-start">
          <Sidebar />
          <div className="edt-main min-w-0 flex-1">
            <Header />
            <TrustBadges />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/driving-tests" element={<DrivingTests />} />
              <Route path="/claims" element={<Claims />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/faq-contact" element={<FaqContact />} />
            </Routes>
            <Footer />
          </div>
        </div>
        <FloatingContact />
      </BrowserRouter>
    </div>
  );
}

export default App;
